<div class="dialog">

  <h2 mat-dialog-title style="text-align: center;">
    {{title}}: {{itemName}} ({{catalogOriginalValue.risk}}%)
  </h2>
  <br>

  <div class="dialog-box-s">
    <div class="dialog-box dialog-box-m">
      <form [formGroup]="formGroup">
        <mat-label>{{variables.risk}} (%)</mat-label>
        <mat-form-field class="mat-form-field-infix" appearance="outline">
          <input matInput type="number" formControlName="riskCtrl" step="0.01" (input)="onInputChange($event)"
            [required]="true" [min]="0" [max]="100">
          @if (invalidInput) {
          <mat-hint class="error-hint">{{errorMessage}}</mat-hint>
          }
        </mat-form-field>


      </form>
    </div>
  </div>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" color="red" textColor="white" message="{{variables.cancel}}"
        mat-dialog-close></app-button>
      <app-button typeBtn="primary" message="{{variables.confirm}}" (click)="doAction()"></app-button>
    </mat-dialog-actions>
  </div>
</div>